import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en.json';
import vi from './i18n/vi.json';

const saved = localStorage.getItem('easyweb-language');
const detected = navigator.language.toLowerCase().startsWith('vi') ? 'vi' : 'en';

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, vi: { translation: vi } },
  lng: saved || detected,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (language) => {
  localStorage.setItem('easyweb-language', language);
  document.documentElement.lang = language;
  document.title = i18n.t('meta.title', { lng: language });
});

document.documentElement.lang = i18n.language;
document.title = i18n.t('meta.title');
export default i18n;
